// Global
import React from 'react';

// Local
import { RecipeResponse } from 'lib/services/models/content-response';
import styles from './RecipeTradeMarks.module.scss';

export interface RecipeTradeMarksProps {
  recipe?: RecipeResponse;
  copyrightText?: string;
}

/**
 * The `Trademarks` API field is typed as `unknown[]`, so only usable strings are kept.
 */
export function getTrademarkLines(trademarks?: unknown[] | null): string[] {
  if (!trademarks?.length) {
    return [];
  }

  return trademarks.reduce<string[]>((lines, trademark) => {
    if (typeof trademark === 'string' && trademark.trim()) {
      lines.push(trademark.trim());
    }

    return lines;
  }, []);
}

export function RecipeTradeMarks({ recipe, copyrightText }: RecipeTradeMarksProps) {
  const trademarkLines = getTrademarkLines(recipe?.Trademarks);

  if (!trademarkLines.length && !copyrightText) {
    return <></>;
  }

  return (
    <section
      className={styles.recipeTradeMarksWrapper}
      data-component="authorable/shared/recipe/recipedetail/recipetrademarks"
    >
      <div className={styles.recipeTradeMarks}>
        {trademarkLines.length > 0 && (
          <ul className={styles.trademarkList}>
            {trademarkLines.map((trademark, index) => (
              <li className={styles.trademark} key={`${index}-${trademark}`}>
                {trademark}
              </li>
            ))}
          </ul>
        )}
        {copyrightText && <div className={styles.copyrightText}>{copyrightText}</div>}
      </div>
    </section>
  );
}

export default RecipeTradeMarks;
